import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IMucTriNangReducer } from "../../reducer-model/category/IMucTriNangReducer";
import { IMucTriNangActionTypes } from "../../action-types/category/IMucTriNangActions";
import { IMucTriNang } from "../../../model/respone/category/IMucTriNang";

const iniState: IMucTriNangReducer = {
  status: eReducerStatusBase.is_not_initialization,
  mucTriNangs: [],
  mucTriNangEditing: {} as IMucTriNang,
};

export const mucTriNangReducer = (
  state: IMucTriNangReducer = iniState,
  action: IMucTriNangActionTypes
): IMucTriNangReducer => {
  switch (action.type) {
    case "MUC_TRI_NANG_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "MUC_TRI_NANG_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        mucTriNangs: action.payload,
      };
    case "MUC_TRI_NANG_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "MUC_TRI_NANG_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "MUC_TRI_NANG_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "MUC_TRI_NANG_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "MUC_TRI_NANG_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "MUC_TRI_NANG_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "MUC_TRI_NANG_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "MUC_TRI_NANG_SHOW_EDIT_MODAL":
      return {
        ...state,
        mucTriNangEditing: action.payload,
        isShowEditModal: true,
      };
    case "MUC_TRI_NANG_CLOSE_EDIT_MODAL":
      return {
        ...state,
        mucTriNangEditing: undefined,
        isShowEditModal: false,
      };
    default:
      return state;
  }
};
